import { Box, Tab, Tabs } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { commonToolItems } from '../configs/toolItemsConfig'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { useSelector } from 'react-redux'

const userSelector = createSelector(
  [(state: RootState) => state.auth],
  (auth) => auth.user,
)

function AdminSettings() {
  const boxRef = useRef<HTMLDivElement>(null)
  const [boxHeight, setBoxHeight] = useState(0)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const user = useSelector(userSelector)

  const settingsTool = commonToolItems.find((tool) => tool.label === 'Settings')
  const adminSettings = !!settingsTool
    ? settingsTool.nestedRoutes?.find(
        (route) => route.label === 'Admin Settings',
      )
    : null
  const tabs =
    !!user && !!adminSettings && adminSettings?.nestedRoutes
      ? adminSettings?.nestedRoutes?.filter(
          (route) => !!!route.roles || route.roles.includes(user?.role.name),
        )
      : []
  const SelectedComponent =
    !!adminSettings && adminSettings.nestedRoutes
      ? adminSettings?.nestedRoutes[selectedTabIndex]
        ? adminSettings?.nestedRoutes[selectedTabIndex].component
        : null
      : null

  const handleTabClick = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTabIndex(newValue)
  }

  useEffect(() => {
    const calculateHeight = () => {
      if (boxRef.current) {
        setBoxHeight(boxRef.current.clientHeight)
      }
    }

    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => {
      window.removeEventListener('resize', calculateHeight)
    }
  }, [])

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box ref={boxRef} sx={{ display: 'flex ' }}>
        <Tabs
          value={selectedTabIndex}
          onChange={handleTabClick}
          sx={{
            minHeight: 0,
            '& .MuiTabs-indicator': {
              justifyContent: 'center',
              backgroundColor: '#1705E5',
            },
            '& .MuiTabs-indicatorSpan': {
              backgroundColor: '#1705E5',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              disableRipple
              key={index}
              label={tab.label}
              sx={{
                minWidth: 0,
                minHeight: 0,
                alignItems: 'start',
                textTransform: 'capitalize',
                color: '#04002E',
                fontSize: '0.82rem',
                display: 'flex',
                pl: 0,
                pr: 0,
                mr: '2rem',
                py: '0.75rem',
                justifyContent: 'flex-start',
                '&.Mui-selected': {
                  color: '#1705E5',
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ display: 'flex', height: `calc(100% - ${boxHeight}px)` }}>
        {SelectedComponent && <SelectedComponent />}
      </Box>
    </Box>
  )
}

export default AdminSettings
